import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import LoadingButton from '@mui/lab/LoadingButton';
import { formatDateLabel } from '../../../../../lib/dayjs';
import { EScheduleSteps, updateScheduleSteps } from '../../../../../features/schedule/schedule-slice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../store';
import { Divider } from '../../../Divider';
import { DialogContent } from '../../styled';
import { useScheduleReturnConfirmationMutation } from '../../../../../services/schedule.service';
import { clearCalendarSelected, resetCalendarsState } from '../../../../../features/calendar/calendar-slice';
import { ScheduleAnalyticsTrackerInstance } from '../../../../../lib/gtm';

const ScheduleReturn = () => {
  const {
    schedule: { dateStart, dateStartISO },
    calendar: {
      calendarSelected,
      calendarsAvailables,
      doctorId,
      journey: { journeyid, product }
    }
  } = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const [scheduleReturnConfirmation, { isLoading }] = useScheduleReturnConfirmationMutation();
  return (
    <>
      <DialogContent>
        <Typography>Depois de agendar, você ainda poderá alterar a data da consulta.</Typography>
        <Divider />
        <Typography variant="body1B">Data do retorno</Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Typography>{formatDateLabel(dateStart)}</Typography>
          <Button
            variant="inline"
            disabled={isLoading}
            onClick={() => {
              dispatch(
                updateScheduleSteps({
                  currentStep:
                    calendarsAvailables.length > 1 ? EScheduleSteps.returnAppointment : EScheduleSteps.openCalendar,
                  previousStep: calendarsAvailables.length > 1 ? EScheduleSteps.returnAppointment : EScheduleSteps.idle
                })
              );
              if (calendarsAvailables.length > 1) dispatch(clearCalendarSelected());
            }}
          >
            Alterar
          </Button>
        </Box>
      </DialogContent>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <LoadingButton
          loading={isLoading}
          variant="contained"
          onClick={() => {
            scheduleReturnConfirmation({
              calendarid: calendarSelected?.id as string,
              dateStart: dateStartISO,
              journeyid,
              returnSchedule: true,
              userid: doctorId || '',
              timezone: '-3'
            })
              .unwrap()
              .then(() => {
                ScheduleAnalyticsTrackerInstance.setProperties({
                  scheduleFlow: 'return_schedule',
                  scheduleDateStart: dateStart || '',
                  scheduleCalendarId: calendarSelected?.id || '',
                  scheduleCalendarAlias: calendarSelected?.alias || '',
                  journeyId: journeyid || '',
                  scheduleProductId: product?.id || ''
                }).sendGAEvent();
                dispatch(updateScheduleSteps({ currentStep: EScheduleSteps.sendFile, previousStep: EScheduleSteps.idle }));
                dispatch(resetCalendarsState());
              })
              .catch(error => {
                console.log(error);
              });
          }}
          endIcon={<ArrowForwardIcon />}
        >
          Salvar
        </LoadingButton>
      </Box>
    </>
  );
};

export default ScheduleReturn;
